<template>
  <div style="width: 100%">
    <v-row no-gutters>
      <span class="checkout-h6 accent--text" style="font-weight: 700">{{
        $t("payment.howWantPay")
      }}</span>
    </v-row>
    <v-row v-if="paymentDetails.credit_card" class="my-4" no-gutters>
      <Card
        :couponCard="couponCard"
        :loading="loading"
        @purchase="$emit('purchase')"
      />
    </v-row>
    <v-row v-if="paymentDetails.pix && !couponCard" class="my-4" no-gutters>
      <Pix :loading="loading" @purchase="$emit('purchase')" />
    </v-row>
    <v-row
      v-if="
        paymentDetails.billet &&
        !couponCard &&
        buyer.typeDocument !== 'foreigner'
      "
      class="my-4"
      no-gutters
    >
      <Billet
        :productsTotal="productsTotal"
        :loading="loading"
        @purchase="$emit('purchase')"
      />
    </v-row>

    <v-row v-if="paymentDetails.invoice" class="my-4" no-gutters>
      <Invoice :loading="loading" @purchase="$emit('purchase')" />
    </v-row>
  </div>
</template>

<script>
import Pix from "./types/Pix.vue";
import Card from "./types/Card.vue";
import Billet from "./types/Billet.vue";
import { mapGetters } from "vuex";
import Invoice from "./types/Invoice.vue";
export default {
  props: ["paymentDetails", "productsTotal", "loading"],
  components: { Pix, Card, Billet, Invoice },
  computed: {
    ...mapGetters(["couponCard", "buyer"]),
  },
};
</script>

<style>
.option-active {
  border: 1px solid #1976d2;
  width: 100%;
  cursor: pointer;
}

.option-deactive {
  border: 1px solid #dfdfdf;
  width: 100%;
  cursor: pointer;
}
</style>
